export * from './GoalTemplateDucks'
